import { inject, Injectable } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { utils } from 'src/app/shared';

export const IsTeoremaMatchGuard: CanMatchFn = (route, segments) => {
  const companyGroup = utils.getCompanyGroup();

  if (companyGroup.alias === 'teorema') {
    return true;
  }

  return false;
};

export const isTeoremaActivateGuard: CanActivateFn = () => {
  const router = inject(Router);

  const companyGroup = utils.getCompanyGroup();
  const user = utils.getUser();

  if (companyGroup.alias === 'teorema') {
    return true;
  }

  router.navigate(['/acesso-negado']);
  return false;
};
